import axios from "axios";

const API_BASE = '/onsite-drycleaning/clsystem/api/v1';

export function fetchRoutes(params = {}) {
    return axios.get(API_BASE + '/drives-in-route', {params: params})
}

export function updateRoute(params = {}) {
    const route = params.route.map((driveInRoute) => (
        {data: driveInRoute.drive, courier: driveInRoute.courier, scheduleId: driveInRoute.scheduleId}
    ));
    return axios.put(API_BASE + '/drives-in-route/' + params.routeId, {route: route})
}

export function createRoute(params = {}) {
    const route = params.route.map((driveInRoute) => (
        {data: driveInRoute.drive, courier: driveInRoute.courier, scheduleId: driveInRoute.scheduleId}
    ));
    return axios.post(API_BASE + '/drives-in-route', {date: params.date, route: route})
}
